import { cn, getCustomInputClass, updateFontSizes } from '@utils'
import { InputType } from '@/constants'
import ChoiceFields from './ChoiceFields'
import InputButton from './InputButton'
import StepTitle from '@/components/StepTitle'
import StepMedia from './StepMedia'

// Generic funnel-step renderer: turns a session's valid_inputs/additional_inputs
// into buttons, or a ChoiceFields list for Radio/Select steps. Shared by the
// funnel's popup flow and the OMP action drawer so both render backend steps
// identically.
const StepInputArea = ({
  session,
  onSelectInput,
  onBack,
}: {
  session: any
  onSelectInput: (input: any, inputData?: Record<string, any>) => void
  onBack?: () => void
}) => {
  const inputs = (session?.valid_inputs as any[]) || []
  const additionalInputs = (session?.additional_inputs as any[]) || []
  const isEnhancedContent = !!session?.enhanced_mode
  const showInlineInputs =
    (inputs.length > 0 || additionalInputs.length > 0) && (!isEnhancedContent || !session?.content)

  const isChoiceFields = [InputType.Radio, InputType.Select, InputType.RadioSelect].includes(Number(inputs[0]?.type))

  return (
    <div className="inputs">
      <StepTitle
        session={session}
        subtitle={
          !isEnhancedContent && session?.subtitle ? (
            <div dangerouslySetInnerHTML={{ __html: updateFontSizes(session.subtitle) }} className="option rich-text" />
          ) : undefined
        }
        content={
          session?.content?.length ? (
            <div
              className="rich-text w-full"
              dangerouslySetInnerHTML={{ __html: updateFontSizes(session.content as string) }}
            />
          ) : undefined
        }
        staticData={<StepMedia session={session} />}>
        {!isEnhancedContent && session?.label && (
          <div
            dangerouslySetInnerHTML={{ __html: updateFontSizes(session.label as string) }}
            className="how-can rich-text"
          />
        )}
      </StepTitle>

      {showInlineInputs &&
        (isChoiceFields ? (
          <ChoiceFields session={session} onSubmit={onSelectInput} onBack={onBack} />
        ) : (
          <div className="step-button-row flex flex-col gap-3 mb-3 mt-2">
            {inputs.map((input: any) => (
              <InputButton
                key={`step-input-${input.id}`}
                input={input}
                className={getCustomInputClass(session, input, false)}
                onClick={() => onSelectInput(input)}
              />
            ))}
            {additionalInputs.map((input: any) => (
              <InputButton
                key={`step-additional-${input.id}`}
                input={input}
                className={cn('btn-outline-success', getCustomInputClass(session, input, false))}
                onClick={() => onSelectInput(input)}
              />
            ))}
          </div>
        ))}
    </div>
  )
}

export default StepInputArea
